import { LookupItem, NamedId } from "@amsanalytics/react-shared-library";
import { MS_PER_MINUTE } from "@progress/kendo-date-math";

export const Constants = {
  roleApplicantId: 'CBA13EC8-D9B6-4074-90C5-BDD7E2CC7A4F',
  roleCoApplicant1Id: 'EEF728E9-8BFA-49FA-8AC1-CC42573618EA',
  roleCoApplicant2Id: '63925D33-F9BC-41C0-BD06-E013442FAA70',
  emptyGuid: '00000000-0000-0000-0000-000000000000',
  newApplicationId: 'e90d61f6-76b6-4b7c-8ca4-6b44f4f4ee9f',
  newApplicationStatusId: '74c5f746-78c5-49ac-8c17-92a30d5be807',
  coApplicantId: 'eef728e9-8bfa-49fa-8ac1-cc42573618ea',
  systemUserId: 'd662bce1-5e24-4f59-b9e9-2934caa2de2e',
  biweeklyPayTypeId: '79f29bc8-63ae-487d-b1fd-dd8e8a758709',
  roles: {
    // administratorId: 'c4811abc-f430-4eca-8780-39f63ffe524f',
    collectionsManagerId: 'e1029716-65c6-4eac-a4eb-5c6102e515ff',
    collectorId: '6d86921e-938c-4a09-9a33-f592487da899',
    complianceId: '8537138d-07ac-45c9-9f9a-0a2e93523590',
    creditManagerId: '302adcb0-7639-4f6c-93e7-77d8d180a211',
    investigatorId: '1551dd4b-3ec5-42df-a02f-8da7c0727020',
    investigatorManagerId: '5ab4851a-1cce-4bbf-b086-f65446d2d9a7',
    regionalManagerId: 'd95bc282-3877-4f95-83ac-bc60d2c6b8f2',
    dealerId: '9d0394ed-ca63-45a9-afcc-511b4d792cd5',
    salespersonId: '330a8946-264f-4c8b-92cb-423ca4c87b16',
    salesManagerId: 'cf462515-9570-4e98-a4f4-09fe668bcb6f',
    verifierId: '8b6dda33-d7c0-40f4-9486-6d1271a609c2',
    underwriterId: 'be92f02a-676e-4297-a48b-337f8c926e00',
    // administratorId: 'c4811abc-f430-4eca-8780-39f63ffe524f', // TODO: FIX THIS CFI HAS DIFF ADMIN ID than all other clients.
    administratorId: '7010add5-1acf-4aee-ab66-63b07fbca60e',
    reviewerId: 'cbed5fa8-ae02-4a8e-a5c3-30fb4eebfc03',
    reportViewerId: "6D76CF13-4E63-469E-8214-40D5CA8507E0",
    marketingId: "A8477FD5-A176-469B-8975-344F49907D02",
    storeManagerId: 'ceece508-f1fb-45a3-a6f4-166927f71466',
    underwritingManagerId: 'c8d83e75-36e5-45b7-8dce-46f29855a4cd'
  },

  applicationStatuses: {
    new: '74C5F746-78C5-49AC-8C17-92A30D5BE807',
    sales: '23C7FBAD-2F8A-4948-B777-AEA0F7532236',
    underwriting: '16FF897F-5EFF-4919-A9E9-D2258E1759E5',
    conditionsTentativelySatisfied: '30792AF9-54E5-429B-AE1C-88B99A196FB6',
    rehash: '67DFFDD2-1AF7-483F-A586-E2697F8F19B0',
    conditionallyApproved: '598DF346-837F-4675-B8C6-C96D65CD93B7',
    approved: '7D2C21A5-FA9B-423B-BEFE-335067650996',
    desking: '4F0847BE-A121-4BE9-81B5-32EC1B9F3DA4',
    closedLost: 'D47FE765-958B-4B23-9E3A-71A18AF84D9C',
    denied: 'D474A446-2298-42E0-BCB8-D59DE21206E5',
    investigation: 'F0B577C8-7BA5-4524-85CF-38EF5B7DB7B0',
    funded: '13EA3E70-0908-4221-A58C-A03618FBC0F3',
    collection: 'E1AB74BE-D2EE-4AA1-8091-79AE525B568C',
    hold: 'A7901B15-B647-4ACC-BA86-FB99A2069803',
    closed: '84952ACE-EAA8-499F-9F32-829D1ABE4165', // Made for ACC because they have a "Closed" and a "Lost" status
    archived: '1F9DF23A-BD88-4515-B421-5562DD15C758',
    additionalInformationRequired: 'D48EB79A-8359-462E-BA04-CB7A5D894F92',
    finalizedPosted: "2B9A397F-6BB3-44BF-8E0B-8A471BEC9438",
    unwound: "A1D02F47-AA65-49F9-B883-DC2307C9FA32",
    contractReceived: "DE264313-AB22-4D07-825D-6E45D100B31C",
    readyToBook: '7360650E-35B1-414C-BEFB-36B8233399B3',
    verificationIncomplete: '14CB04C5-A11E-4A1D-BF69-9B221D92717D',
    dealerReview: 'B3A1E6D4-7F92-4C8A-9D15-2E3F0A8B6C71'
  },

  applicationQueues: {
    myWork: '1ebf78da-8ffc-4155-8579-c78d006d40b2',
    unassigned: '5640aceb-5541-4b55-b14f-89069157150b',
    all: '19217811-8fdf-4e91-811e-d19ef90866ae',
    exception: 'fecf20eb-34b2-4361-b5b1-c6ab0fbd64c7',
    rehash: '0955d782-7087-4b10-b8f9-c12d02c9fc3a',
    verifierUnassigned: 'a2881ce1-5218-443b-b98f-c1d509fe1ac2'
  },

  applicationExceptionStatuses: {
    raisedId: '955b5414-43aa-48a5-852a-585a19ea27d2',
    grantedId: 'eca7df0b-0210-4084-a56c-b750d5a1fe61',
    deniedId: '69570889-3591-4000-9bce-0e1caa5b71f4'
  },

  applicationStatusNames: {
    approved: '',
    denied: '',
    conditionallyApproved: '',
    desking: ''
  },

  checklistItemStatuses: {
    notStartedId: '3e67a0cd-5a5a-430a-8dfe-c3e50daff701',
    inProgressId: 'cc49df57-12c7-471f-9d7c-afcbfb3335ae',
    completedId: '8329f7e5-9747-4c1d-9ecf-4adf6348900d',
    exceptionId: 'dd1dfdff-fe6a-42bc-83fb-feddbb0375aa',
    problemId: '984fc6f5-dd47-4c85-a354-bfb9a5ecde52'
  },

  stipulationStatuses: {
    notReceived: 1,
    received: 2,
    verified: 3,
    withdrawn: 4,
    issue: 5,
    exception: 6
  },

  stipulationCategoryStatuses: {
    approved: "1dc77a2d-ce76-4d6f-b9da-83d973d2692b",
    unapproved: "8b2bbfa1-090c-4adb-aa0a-f4fb9a42f1c0"
  },

  dealerServiceHistoryTypes: {
    acknowledgementReceived: '682f32bf-e208-4d91-9680-10f2dc326c88',
    decisionSent: 'f0eabd30-5fbd-4da9-b622-473c003b99db',
    commentsReceived: '2f5a7122-be8e-4819-98c8-633a16919edb',
    commentsSent: '569397dc-bf06-4be1-821f-8569fa67797d',
    applicationReceived: '822ce4e4-341a-4f9f-9ec7-9a837b1dd80f',
    documentsReceivedAcknowledgementSent: '7c36ac08-d76f-4596-ae20-2eac1cb87d15'
  },
  availability: {
    away: 'bc096d21-8b5d-428f-a92e-feb234923c3f',
    available: '1c49f52f-a5a0-4543-ba33-87c0d4ac26a3',
    doNotDisturb: '04ffc0e2-b28f-454d-a98a-4acd8ee98b9c'
  },
  quoteScoreTypes: {
    stability: '26B4F40B-1B61-4AF1-97A5-C4B348CB7B8B',
    structure: '07A18EB7-2C24-4002-9509-DD2779E458BB'
  },

  customerEmploymentStatuses: {
    notVerifiedId: "a40134e5-5dd7-4034-bfcd-c84971a5a2cf",
    verifiedId: "730345e7-575c-40c7-a671-afd958bafb56",
    exceptionId: "4f526d08-a502-44c8-b933-7e048ae37fe4",
    issueId: "bac33d84-6ffe-46e2-a0fb-7a3505b200da"
  },

  organizationTypes: {
    storeId: '619905cc-6d66-42de-95a3-0ff41739f2fe',
    regionId: '42a8555d-8612-4493-9664-75eb8a2c4235',
    bdcId: 'cdf7e0a4-038c-49ed-8c1c-685b9c1d1850'
  },
  bookoutSources: {
    jdPower: "97ff2b4b-a79b-46d4-abd8-27f9968b23e1",
    kellyBlueBook: "1cd8d9dd-10ff-4274-b728-20042d755a86",
    blackBook: "9a6c83bc-58fe-4d57-b1ba-a85ace371f5b",
    other: "af455e18-1fe5-4da6-9910-9c6eca8d14a4",
  },
  appSources: {
    dealerFlow: "DEALER FLOW",
    onlineApp: "Online Application",
    los: "LOS",
    dealerTrack: "DEALERTRACK",
    routeOne: "ROUTEONE",
  }

};

export const INCOMPLETE_INSURANCE_MESSAGE = 'You must complete the required fields on the vehicle insurance before you can perform this action.';

export const indirectApprovalDecisionCodes = ['A', 'PA'];
export const indirectConditionalDecisionCodes = ['CO', 'O'];
export const indirectDenialDecisionCodes = ['D', 'DC'];
export const allIndirectSubmissionDecisionCodes = [
  ...indirectApprovalDecisionCodes, 
  ...indirectConditionalDecisionCodes, 
  ...indirectDenialDecisionCodes];

/**
 * Section keys for granular unlock of posted/locked applications.
 * Must match the backend PostedApplicationUnlockSections constants.
 */
export const PostedAppUnlockSections = {
  Vehicle: 'Vehicle',
  Budget: 'Budget',
  Quoter: 'Quoter',
  CustomerDetails: 'CustomerDetails',
  CustomFields: 'CustomFields',
  Status: 'Status',
  Assignments: 'Assignments',
} as const;

export type PostedAppUnlockSection = typeof PostedAppUnlockSections[keyof typeof PostedAppUnlockSections];

/** Sections that remain editable on locked applications without any unlock. */
export const ALWAYS_EDITABLE_SECTIONS = ['Documents', 'Insurance', 'References', 'Notes', 'Stips'] as const;

export const applicationStatusesAfterDeskingToAms = [
  Constants.applicationStatuses.desking,
  Constants.applicationStatuses.investigation,
  Constants.applicationStatuses.funded,
  Constants.applicationStatuses.hold,
  Constants.applicationStatuses.closed,
  Constants.applicationStatuses.finalizedPosted,
  Constants.applicationStatuses.unwound
];

export const applicationDecisionedStatuses = [
  Constants.applicationStatuses.approved,
  Constants.applicationStatuses.denied,
  Constants.applicationStatuses.conditionallyApproved,
  Constants.applicationStatuses.desking,
  Constants.applicationStatuses.finalizedPosted,
  Constants.applicationStatuses.unwound,
  Constants.applicationStatuses.underwriting
];

export const indirectStipulationStatuses = {
  passed: 'A2FBF50D-D1F6-44B7-BAD6-1CDD354D9E69',
  failed: '103BCF57-BDBE-42FE-995C-6117F35E17D2',
  waived: '93F0C150-F4A4-4251-9E51-ED4797F6D015',
  missingDocuments: '36C01048-E662-4FD1-BC40-E4578C87804D'
}

// List of phone number types.
export const phoneNumberTypes: string[] = ['Home', 'Cell', 'Work'];

// Maps a stipulation status ID to its associated name.
export const stipulationStatusMap = new Map<number, string>([
  [1, "Not Received"],
  [2, "Received"],
  [3, "Verified"],
  [4, "Withdrawn"],
  [5, "Issue"],
  [6, "Exception"],
]);

// Default disclosure text.
export const defaultDisclosure: string = `By clicking the I Agree checkbox and Submit, I consent to have my credit file accessed for purposes of prequalifying for a vehicle loan.
This is a soft inquiry and will not impact my credit score. I agree to the Privacy Notice, Terms and Conditions and I acknowledge I may be contacted. I understand that I might not prequalify depending on the prequalification criteria. By submitting this application, I acknowledge that I will receive responses by text or email from our customer care team.`;

export const defaultHelpDeskUrl: string = `https://forms.zoho.com/edean/form/SubmitaTicket'`;


// List of permissions an employee could have access to.
export const permissions = {
  contacts: "B655002B-D4F3-43A5-989C-104E40B2FC1F",
  users: "4B7BCE93-F793-41CB-AE5F-236229D77BEF",
  messageTemplates: "4C96DD69-B871-4D47-9936-F3C39CA9E856",
  mediaUploader: "D16722F8-8E9D-41DA-A94C-2AF67BE48364",
  workflows: "F534E965-983F-4EB7-965A-B46079B20616",
  conversionJourney: "4127F119-E8C1-46ED-8DB0-24E8809207A6",
  managerDashboard: "11542C63-797E-4C27-96BF-934FDA244D81",
  salesAssociateDashboard: "437C16EF-27E3-4E8A-8059-B9F00349E8DF",
  organizations: "14CD9262-1BE9-4573-A526-C221F531C6F0",
  creditApplicationConfiguration: "20D7390D-071C-4871-8ABF-A0793A499C0D",
  notifications: "314A4EAB-D2DA-4D1C-8C00-E474AE0CA209",
  leadReassignment: "6C75D8E9-322F-414E-9733-FAE009DB3C4F",
  employees: "5F34180F-2092-4CFE-8512-00F906808C93",
  crmApplicationNotifications: "52469182-B6A8-42FE-8892-3A31D36BBF44",
  appointments: "15528b18-0fc0-41be-a211-7243e7ce1e91",
  documents: "3CE7F5E9-A6EE-4F7B-B302-B18035DF0980",
  reports: "a25b4ea3-62c8-444c-a4e0-6049cbb59f25",
  campaigns: "a1f5c495-0452-46c2-959a-78b8a5c2e0ff",
  vehicleACV: "FCC00A69-FC74-46F3-B997-E927B42CAA0B",
  canPullCredit: "6261C2EB-63A8-41AF-990D-46D56BA20EC3",
  canEnterLos: "3F090A32-9631-4956-A549-BD1E57A46CAB",
  viewProfitCalculator: "A3450C61-3443-4710-9ED7-D4A2EC8411C8",
  viewAuditLog: "031BFA41-1D31-4438-AA2D-21EC3642802F",
  losVehicleTab: "77FEBD9E-AE2A-4130-B99F-A0367B568B73",
  losCustomFieldsTab: "2191EC26-26FA-4FF6-BAFA-7B4CAB6CE6C8",
  losBudgetTab: "FE565BD1-95AB-4DDB-8A6A-2E47088A4BBB",
  losBureauTab: "54011BF8-873C-4BD3-BB1E-E0B1E1C1A637",
  losNotesTab: "36385086-2F09-4EB3-8E51-187982DB969E",
  losStipsTab: "BF1E415E-CF34-40A6-A65D-D112511AB142",
  losJdPowersportHistoryTab: "DBEDF420-B1BA-4C6F-8BC9-A9454801C5C5",
  applicationListReport: "8AB6289D-255C-4077-8D44-9FD8476F6D01",
  applicationExportToExcel: "E350BFCF-3669-4397-BCC3-8CED88C4A47C",
  losUnderwriterNotesTab: "353BD2BF-402C-4CA6-AFDB-2FD234C431C0",
  existingCustomerInformation: "9319D588-55E9-4985-9094-6EA967A52B17",
  losNotificationsTab: "B1A488CB-21CA-49FD-8CE0-236E89313D63",
  mergePdfDocuments: "CEC657C0-37B1-4DC9-B270-CC0ECBE4E3CF",
  applicationQueueColumnSortOrder: "8848B997-2C28-4EB6-991E-11FE8EC8EFBD",
  inventoryMileage: "f092d3ef-a837-4174-ace7-b25351692d94",
  nonUnderwriterViewCalculatedColumn: "A81910CA-CCE1-4C61-8EF5-0BDB48C62792",
  pullCreditOverride: "92D96935-D03C-46A9-BB67-6F3A4CF5A2B9",
  accessApplicationsAcrossLocations: "2F0288B4-1B80-403D-A8CD-32B962B09986",
  copyApplication: "676895A3-F049-4A07-8B53-B0E14CE00BAC",
  vehicles: "0DC3CFE3-086C-4CA1-ADA1-B2AE99489CB1",
  viewPreviousAmsLoanDetails: "DBF1620D-0A55-4C87-AE96-78B57A71F6B6",
  references: "23FD4678-2B2A-4E53-A17B-95852C19058C",
  verifyReferences: "E94CC505-7141-4BA3-BB42-133C0A0AFB8F",
  finicityBankVerification: "85199C3B-C06E-41F2-8B71-A006A8D12CB0",
  commission: "39078e86-0b39-43e1-9ae7-6068730d8ba4",
  losWashoutTab: "4782EBE7-8305-4109-91C5-114AC82CB242",
  unlockPostedApplication: "B3A1D7E2-5F84-4C69-9A2B-8E6F1D3C7A50",
  checkMyDriverDocumentUpload: "A7C4E8B1-3D62-4F95-8A1B-5E9D7C2F4A63",
  // Must match Constants.Permissions.AddCustomStipulations and the AddCustomStipulationCategoriesAndPermission migration seed.
  addCustomStipulations: "EE0450E2-37C6-4DAE-948F-5E984AF2A3A3"
};

export const OrganizationIds = {
  bdc: 'cdf7e0a4-038c-49ed-8c1c-685b9c1d1850',
  region: '42a8555d-8612-4493-9664-75eb8a2c4235',
  store: '619905cc-6d66-42de-95a3-0ff41739f2fe',
  storageLot: '4a4f1406-9387-4400-914a-a6d17af68971'
};

// List of relationship types for users to select from the dropdown menus when creating applications.
export const relationshipTypes: LookupItem[] = [
  {
    id: '0',
    name: 'Applicant',
    description: 'Applicant',
    sortOrder: 0
  },
  {
    id: '1',
    name: 'Spousal',
    description: 'Spousal',
    sortOrder: 1
  },
  {
    id: '2',
    name: 'Parental',
    description: 'Parental',
    sortOrder: 2
  },
  {
    id: '3',
    name: 'Other',
    description: 'Other',
    sortOrder: 3
  },
];


export const OverviewLayouts = {
  buyHerePayHere: [
    { order: 0, rowSpan: 1, colSpan: 2, col: 3 },
    { order: 0, rowSpan: 1, colSpan: 2, col: 3 },
    { order: 2, rowSpan: 1, colSpan: 1, col: 1 },
    { order: 4, rowSpan: 2, colSpan: 1, col: 1 },
    { order: 3, rowSpan: 1, colSpan: 1, col: 1 },
    { order: 1, rowSpan: 1, colSpan: 1, col: 2 },
    { order: 13, rowSpan: 4, colSpan: 3, col: 2 },
    { order: 7, rowSpan: 4, colSpan: 1, col: 5 },
    { order: 12, rowSpan: 1, colSpan: 1, col: 5 },
    { order: 5, rowSpan: 1, colSpan: 1, col: 5 },
    { order: 6, rowSpan: 1, colSpan: 1, col: 5 },
    { order: 8, rowSpan: 1, colSpan: 1, col: 5 },
    { order: 9, rowSpan: 1, colSpan: 1, col: 5 },
    { order: 10, rowSpan: 1, colSpan: 1, col: 5 },
    { order: 11, rowSpan: 1, colSpan: 1, col: 5 },
    { order: 14, rowSpan: 1, colSpan: 1, col: 5 }

  ],
  buyHerePayHereMobile: [
    { col: 1, colSpan: 5, rowSpan: 2 },
    { col: 1, colSpan: 5, rowSpan: 2 },
    { col: 1, colSpan: 5, rowSpan: 2 },
    { col: 1, colSpan: 5, rowSpan: 2 },
    { col: 1, colSpan: 5, rowSpan: 2 },
    { col: 1, colSpan: 5, rowSpan: 2 },
    { col: 1, colSpan: 5, rowSpan: 2 },
    { col: 1, colSpan: 5, rowSpan: 2 },
    { col: 1, colSpan: 5, rowSpan: 2 },
    { col: 1, colSpan: 5, rowSpan: 2 },
    { col: 1, colSpan: 5, rowSpan: 2 },
    { col: 1, colSpan: 5, rowSpan: 2 },
    { col: 1, colSpan: 5, rowSpan: 2 },
    { col: 1, colSpan: 5, rowSpan: 2 },
    { col: 1, colSpan: 5, rowSpan: 2 },
    { col: 1, colSpan: 5, rowSpan: 2 },
    { col: 1, colSpan: 5, rowSpan: 2 },
    { col: 1, colSpan: 5, rowSpan: 2 },
    { col: 1, colSpan: 5, rowSpan: 2 },
    { col: 1, colSpan: 5, rowSpan: 2 },
    { col: 1, colSpan: 5, rowSpan: 2 },
    { col: 1, colSpan: 5, rowSpan: 2 },
    { col: 1, colSpan: 5, rowSpan: 2 },
    { col: 1, colSpan: 5, rowSpan: 2 },
    { col: 1, colSpan: 5, rowSpan: 2 },
    { col: 1, colSpan: 5, rowSpan: 2 },
  ]
};

export const businessRuleOverrideStatuses: NamedId[] = [
  { name: 'Pass', id: 'E1223FC7-3ADF-41B7-A8BA-785CF3D03829' },
  { name: 'Fail', id: '9471DCEF-6552-485D-817E-5B0F72B80CD8' },
  { name: 'Waived', id: '66922E91-F5A2-464E-AA5C-60F9968852D7' }
];

export const businessRuleOverrideStatusTypes = {
  pass: 'E1223FC7-3ADF-41B7-A8BA-785CF3D03829',
  fail: '9471DCEF-6552-485D-817E-5B0F72B80CD8',
  waived: '66922E91-F5A2-464E-AA5C-60F9968852D7'
}

export const millisecondsToRefreshQueue = 5 * MS_PER_MINUTE; // 5 minutes' worth of milliseconds
export const numberOfEmployeeApplicationHistoriesToTrack = 11; // 10 + currently viewed app

export const paymentProcessors = {
  ams: "85308028-9AB3-4855-A7D7-12D0A4882CAF",
  blytzPay: "BB2CB52B-70BF-4FE3-B95B-DBB9C9C01A02",
  payNearMe: "5E02ABEA-0452-4A7C-A671-E64192880A75",
  paymentVision: "21B8EE90-03B0-4373-9866-20894A8EA44C",
  rePay: "B925B6BA-837D-4397-ACAE-36DA5273D343"
}